import { css } from 'styled-components';
import { fontVariables, mediaTemplates } from 'theme/variables';

const mediaQueries = css`
  ${(props) =>
    props.size === 'fs_xxs' &&
    !props.fixedSize &&
    css`
      ${mediaTemplates.l} {
        font-size: ${fontVariables.fs_s};
      }
    `}

  ${(props) =>
    props.size === 'fs_s' &&
    !props.fixedSize &&
    css`
      line-height: 20px;
      ${mediaTemplates.l} {
        line-height: 25px;
        font-size: ${fontVariables.fs_l};
      }
    `}

  ${(props) =>
    props.size === 'fs_md' &&
    !props.fixedSize &&
    css`
      line-height: 20px;
      ${mediaTemplates.l} {
        line-height: 25px;
        font-size: ${fontVariables.fs_xl};
      }
    `}

  ${(props) =>
    props.size === 'fs_l' &&
    !props.fixedSize &&
    css`
      ${mediaTemplates.l} {
        line-height: 25px;
        font-size: ${fontVariables.fs_xxl};
      }
    `}
`;

export default mediaQueries;
